<template>
    <div class="m15" ref="body" v-if="soma > 0">
        <div class="row">
            <hr />
            <h4 class="simulator-title loaded">Padrão de Vida</h4>
            <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        </div>
        <div class="row">
            <div class="col l3"></div>
            <div class="col l6 s12">

                <div style="text-align:center;" v-if="datachart.length > 1">
                    <!-- <pie-chart ref="barchat" :myData="datachart" :myLabel="labelchart"/> -->
                    <pie-chart2 ref="barchat" :myData="datachart" />
                </div>
                <div class="block" style="margin-top:15px;margin-bottom:15px;">
                    <div align="center">Padrão de Vida Atual</div>
                    <div class="total" align="center">Total: {{ saldo }}</div>
                </div>
            </div>
            <div class="col l3"></div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                <div class="row">
                <div class="texto" style="text-align:justify">
                    Diante das informações prestadas entendemos que hoje, você e seus dependentes financeiros, tem acesso a um <b style="font-weight:bold;">padrão de vida, moradia, alimentação, educação, saúde, lazer</b>, que consomem aproximadamente {{this.saldo}} ({{this.extenso}})  de sua renda bruta mensal.</div>
                </div>
                <div class="row">
                <div class="texto" style="text-align:justify" v-if="porcentagem">
                    A sua responsabilidade financeira na manutenção desse <b style="font-weight:bold;">padrão de vida atual</b>, conforme informado em nosso processo de <b style="font-weight:bold;">consultoria</b> é de {{this.porcentagem}}% dos {{this.saldo }} ({{ extenso }}) mensais necessários.</div>
                </div>
            </div>
        </div>
        <div class="row">
            <sua-responsabilidade :cliente="cliente" ref="sua_responsabilidade" />
        </div>
    </div>
</template>

<script>
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import PieChart from '@/components/canvas-chart/PieChart'
    import PieChart2 from '@/components/canvas-chart/PieChart2'
    import SuaResponsabilidade from './Responsabilidade'
    import Saudacao from './Saudacao'
    const extenso = require('extenso')

    export default {
        name:'PadraoVida',
        mixins:[utils],
        components: {
            PieChart,
            PieChart2,
            SuaResponsabilidade,
            Saudacao
        },


        computed: {

            responsabilidade() {
                return this.soma * this.porcentagem * 0.01;
            },

            responsabilidade_por_extenso() {
                return this.currency(this.responsabilidade);
            },

            responsabilidade_real() {
                return this.real(this.responsabilidade);
            },

            soma() {
                return ['gastos_fixos', 'lazer', 'seguro_previdencia', 'outros'].reduce((soma, key) => {

                    const n = parseFloat(this.cliente.padrao_vida[key])

                    return (isNaN(n) ? 0 : n) + soma;

                }, 0)
            },

            extenso() {
                return this.currency(this.soma)
            },

            saldo() {
                return this.$options.filters.dinheiro(this.soma);
            },

            porcentagem() {
                return parseFloat(this.cliente.padrao_vida.porcentagem_responsabilidade);
            },
        },
        data () {
            return {
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',
                datachart: [],
                sua_responsabilidade: null,

                titulo: 'Padrão de Vida'
            }
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
        },
        methods:{
            async plot(){

                if (! this.$refs.barchat) return '';

                const canvas = this.$refs.barchat.chart;

                if (canvas) {
                   this.image = canvas.toDataURL("image/png");
                }

                if (this.$refs.sua_responsabilidade) {
                    this.sua_responsabilidade = await this.$refs.sua_responsabilidade.plot()
                }


                return `<div class="m15 page_logo" id="padrao" style="page-break-before: always;">
                    <div class="site"></div>
                    <div class="row">
                        <h4 class="simulator-title loaded">${this.titulo}</h4>
                        ${this.$refs.saudacao.plot()}
                    </div>
                    <div class="grafico">
                    <div class="row" style="${this.datachart.length > 1 ?'display:block;':'display:none;'}">

                        <img src="${this.image}" />
                        <div class="block" style="margin-bottom: 30px">
                            <div align="center">Padrão de Vida Atual</div>
                            <div class="total" align="center">Total: ${this.saldo}</div>
                        </div>

                    </div>
                    </div>
                    <div class="row">
                        <table>
                            <tr>
                                <td width="100%" style="vertical-align: top;">
                                    <p style="font-size:18px;padding-bottom:20px;">
                                        Diante das informações prestadas entendemos que hoje, você e seus dependentes financeiros, tem acesso a um <b style="font-weight:bold;">padrão de vida, moradia, alimentação, educação, saúde, lazer</b>, que consomem aproximadamente ${this.saldo} (${this.extenso}) de sua renda bruta mensal.
                                    </p>

                                    <p style="font-size:18px;${this.porcentagem === 0?'display:none;':'display:block;'}">
                                        A sua responsabilidade financeira na manutenção desse <b style="font-weight:bold;">padrão de vida atual</b>, conforme informado em nosso processo de <b style="font-weight:bold;">consultoria</b> é de ${this.porcentagem}% dos ${this.saldo} (${this.extenso}) mensais necessários.
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style="display:${this.$refs.sua_responsabilidade ? 'block':'none'}">
                        ${this.sua_responsabilidade}
                    </div>
                </div>`;

            },

            async getData(){

                const { padrao_vida } = this.cliente;

                this.datachart = [
                    {label: 'Gastos\nFixos', value: padrao_vida.gastos_fixos},
                    {label: 'Lazer', value: padrao_vida.lazer},
                    {label: 'Seguro Previdên.', value: padrao_vida.seguro_previdencia},
                    {label: 'Outros', value: padrao_vida.outros}
                ].filter(item => item.value !== 0)

            }
        },
        created () {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    display: block;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
.p30{
    padding: 30px;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
    }
}
@media (min-width: 768px) and (max-width:938px){
    .block{
        margin-left: 210px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/PadraoVida.vue